import {create} from 'zustand'

export const useStore = create((set) => ({
    // valores iniciales  
    comercioId : 0,
    comercioNombre: '',
    comercioSucursalId : 0,
    tipo: 0,
    esSocio : '',
    // funciones de asignacion
    asigna: (valorId) => set({comercioId : valorId}),
    asignaSucursal: (valorId) => set({comercioSucursalId : valorId}),
    asignaTipo: (valorId) => set({tipo : valorId}),
    asignaNom: (valorId) => set({comercioNombre : valorId}),
    asignaSocio: (valor) => set({esSocio : valor})

}))



